import {useEffect, useState} from "react";
import { connect } from "react-redux"
import BVASplitter from "../../../../components/BVASplitter/BVASplitter";

import {
  generateAssetSaleDealSplitReport,
  updateAssetSaleDealSplitReport,
} from "../../../../store/modules/financials/actions";
import AssetSaleDealSplitReport from "../../../../models/transactions/AssetSaleDealSplitReport";
import {Divider} from "@mui/material";

function AssetSaleDealStructureSplit({
  assetSaleDealSplitReport,
  currentGoodwillReport,
  currentCompanyBalanceSheetReport,
  dispatchGenerateAssetSaleDealStructureReport,
  dispatchUpdateAssetSaleDealStructureReport
}) {
  // Assets
  const [totalAssetsBuyerBuys, setTotalAssetsBuyerBuys] = useState(0)
  const [equalsAmountBuyerPaysSellerInCashAndNotes, setEqualsAmountBuyerPaysSellerInCashAndNotes] = useState(0)
  const [sellerNetInCashNotesAndRetainedAssets, setSellerNetInCashNotesAndRetainedAssets] = useState(0)
  const [goodwillCheck, setGoodwillCheck] = useState(0)

  // Mounted
  useEffect(() => {
    dispatchGenerateAssetSaleDealStructureReport()
  }, [])

  // Watchers
  useEffect(() => {
    if (
      assetSaleDealSplitReport
      && assetSaleDealSplitReport instanceof(AssetSaleDealSplitReport)
      && currentGoodwillReport
    ) {
      setTotalAssetsBuyerBuys(assetSaleDealSplitReport?.getTotalAssetsBuyerBuys({
        businessGoodwill: currentGoodwillReport.goodwillAmount
      }))

      setEqualsAmountBuyerPaysSellerInCashAndNotes(
        assetSaleDealSplitReport.getEqualsAmountBuyerPaysSellerInCashAndNotes({
          businessGoodwill: currentGoodwillReport.goodwillAmount
        })
      )

      setSellerNetInCashNotesAndRetainedAssets(assetSaleDealSplitReport.getSellerNetInCashNotesAndRetainedAssets({
        businessGoodwill: currentGoodwillReport.goodwillAmount
      }))

      setGoodwillCheck(assetSaleDealSplitReport.getGoodwillCheck({
        businessGoodwill: currentGoodwillReport.goodwillAmount,
        equityValueOfBusiness: currentGoodwillReport.equityValueOfBusiness
      }))
    }
  }, [currentGoodwillReport, assetSaleDealSplitReport])


  const handleStockDealSplit = ({ splitReportKey, assetSaleDealOwner, assetSaleDealItemValue }) => {
    dispatchUpdateAssetSaleDealStructureReport({ splitReportKey }, {
      assetSaleDealOwner,
      assetSaleDealItemValue
    })
  }


  return (
    <div className="w-full" style={{ maxWidth: "64em" }}>
      <div>
        <div className="flex align-center">
          <label className="font-bold text-xl text-center w-1/2">Assets Seller Keeps</label>
          <label className="font-bold text-xl text-center w-1/2">Assets Buyer Buys</label>
        </div>

        <div className="mt-10">
          <div className="border border-neutral-300 p-8 rounded-lg">
            {assetSaleDealSplitReport?.currentAssetsSplit?.map((asset, index) => (
              <div key={index}>
                <BVASplitter
                  itemName={asset.name}
                  itemValue={asset.value}
                  itemSplitAmount={asset.amountFormatted}
                  itemSplitValue={asset.assetSaleDealOwner}
                  onChange={(stockDealSplitValue) => handleStockDealSplit({
                    splitReportKey: "currentAssetsSplit",
                    assetSaleDealOwner: stockDealSplitValue,
                    assetSaleDealItemValue: asset.value
                })} />
              </div>
            ))}
            <div className="w-full flex align-center justify-between mt-5">
              <div className="w-80 font-semibold">Total Current Assets</div>
              <div className="w-40 text-center">
                {assetSaleDealSplitReport?.totalCurrentAssetsSellerKeepsFormatted}
              </div>
              <div className="w-40" />
              <div className="w-80 font-semibold">Total Current Assets</div>
              <div className="w-40 text-center">
                {assetSaleDealSplitReport?.totalCurrentAssetsBuyerBuysFormatted}
              </div>
            </div>
          </div>
        </div>

        <div className="mt-5">
          <div className="border border-neutral-300 p-8 rounded-lg">
            {assetSaleDealSplitReport?.longTermAssetsSplit?.map((asset, index) => (
              <div key={index}>
                <BVASplitter
                  itemName={asset.name}
                  itemValue={asset.value}
                  itemSplitAmount={asset.amountFormatted}
                  itemSplitValue={asset.assetSaleDealOwner}
                  onChange={(stockDealSplitValue) => handleStockDealSplit({
                    splitReportKey: "longTermAssetsSplit",
                    assetSaleDealOwner: stockDealSplitValue,
                    assetSaleDealItemValue: asset.value
                  })}
                />
              </div>
            ))}
            <div className="w-full flex align-center justify-between mt-5">
              <div className="w-80 font-semibold">Total Long Term Assets</div>
              <div className="w-40 text-center">
                {assetSaleDealSplitReport?.totalLongTermAssetsSellerKeepsFormatted}
              </div>
              <div className="w-40" />
              <div className="w-80 font-semibold">Total Long Term Assets</div>
              <div className="w-40 text-center">
                {assetSaleDealSplitReport?.totalLongTermAssetsBuyerBuysFormatted}
              </div>
            </div>
          </div>
        </div>

        <div className="mt-5">
          <div className="border border-neutral-300 p-8 rounded-lg">
            <div className="w-full flex items-center align-center justify-between">
              <div className="w-80" />
              <div className="w-80" />
              <div className="w-80 font-semibold">Total Tangible Assets</div>
              <div className="w-40 text-center">
                {assetSaleDealSplitReport?.totalTangibleAssetsBuyerBuysFormatted}
              </div>
            </div>
            <div className="w-full flex align-center justify-between mt-5">
              <div className="w-80" />
              <div className="w-80" />
              <div className="w-80 font-semibold">Business Goodwill</div>
              <div className="w-40 text-center">
                {currentGoodwillReport?.formattedGoodwillAmount}
              </div>
            </div>
            <div className="w-full flex align-center justify-between mt-5">
              <div className="w-80 font-semibold">Total Assets</div>
              <div className="w-40 text-center">
                {assetSaleDealSplitReport?.totalAssetsSellerKeepsFormatted}
              </div>
              <div className="w-40" />
              <div className="w-80 font-semibold">Total Assets</div>
              <div className="w-40 text-center">
                {totalAssetsBuyerBuys}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-14">
        <div className="flex align-center justify-between">
          <label className="font-bold text-xl text-center w-1/2">Debts Seller Pays Off</label>
          <label className="font-bold text-xl text-center w-1/2">Debts Seller Assumes</label>
        </div>

        <div className="mt-10">
          <div className="border border-neutral-300 p-8 rounded-lg">
            {assetSaleDealSplitReport?.currentLiabilitiesSplit?.map((liability, index) => (
              <div key={index}>
                <BVASplitter
                  itemName={liability.name}
                  itemValue={liability.value}
                  itemSplitAmount={liability.amountFormatted}
                  itemSplitValue={liability.assetSaleDealOwner}
                  onChange={(stockDealSplitValue) => handleStockDealSplit({
                    splitReportKey: "currentLiabilitiesSplit",
                    assetSaleDealOwner: stockDealSplitValue,
                    assetSaleDealItemValue: liability.value
                  })}
                />
              </div>
            ))}
            <div className="w-full flex align-center justify-between mt-5">
              <div className="w-80 font-semibold">Total Current Liabilities</div>
              <div className="w-40 text-center">
                {assetSaleDealSplitReport?.totalCurrentLiabilitiesSellerKeepsFormatted}
              </div>
              <div className="w-40" />
              <div className="w-80 font-semibold">Total Current Liabilities</div>
              <div className="w-40 text-center">
                {assetSaleDealSplitReport?.totalCurrentLiabilitiesBuyerBuysFormatted}
              </div>
            </div>
          </div>
        </div>
        
        <div className="mt-5">
          <div className="border border-neutral-300 p-8 rounded-lg">
            {assetSaleDealSplitReport?.longTermLiabilitiesSplit?.map((liability, index) => (
              <div key={index}>
                <BVASplitter
                  itemName={liability.name}
                  itemValue={liability.value}
                  itemSplitAmount={liability.amountFormatted}
                  itemSplitValue={liability.assetSaleDealOwner}
                  onChange={(stockDealSplitValue) => handleStockDealSplit({
                    splitReportKey: "longTermLiabilitiesSplit",
                    assetSaleDealOwner: stockDealSplitValue,
                    assetSaleDealItemValue: liability.value
                  })}
                />
              </div>
            ))}
            <div className="w-full flex align-center justify-between mt-5">
              <div className="w-80 font-semibold">Total Long Term Liabilities</div>
              <div className="w-40 text-center">
                {assetSaleDealSplitReport?.totalLongTermLiabilitiesSellerKeepsFormatted}
              </div>
              <div className="w-40" />
              <div className="w-80 font-semibold">Total Long Term Liabilities</div>
              <div className="w-40 text-center">
                {assetSaleDealSplitReport?.totalLongTermLiabilitiesBuyerBuysFormatted}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-16">
        <h3 className="font-bold text-center text-2xl">Deal Structure</h3>
        <div className="mt-14">
          <div className="flex justify-between items-center mb-4 px-5 rounded-lg">
            <label className="whitespace-nowrap">(+) Total Assets Purchased by Buyer</label>
            <label className="whitespace-nowrap">{totalAssetsBuyerBuys}</label>
          </div>
          <div className="flex justify-between items-center mb-4 px-5 rounded-lg">
            <label className="whitespace-nowrap">(-) Subtract Liabilities Assumed by Buyer</label>
            <label className="whitespace-nowrap">{assetSaleDealSplitReport?.totalLiabilitiesAssumedByBuyerFormatted}</label>
          </div>
          <Divider />
          <div className="flex justify-between items-center mt-2 mb-6 px-5 rounded-lg">
            <label className="whitespace-nowrap font-semibold">Cash and Note at Close of Escrow from Buyer</label>
            <label className="whitespace-nowrap">{equalsAmountBuyerPaysSellerInCashAndNotes}</label>
          </div>
          <div className="flex justify-between items-center mb-4 px-5 rounded-lg">
            <label className="whitespace-nowrap">(+) Plus Assets Seller Keeps</label>
            <label className="whitespace-nowrap">{assetSaleDealSplitReport?.totalAssetsSellerKeepsFormatted}</label>
          </div>
          <div className="flex justify-between items-center mb-4 px-5 rounded-lg">
            <label className="whitespace-nowrap">(-) Minus Liabilities Seller Pays Off</label>
            <label className="whitespace-nowrap">{assetSaleDealSplitReport?.totalLiabilitiesSellerKeepsFormatted}</label>
          </div>
          <div className="flex justify-between items-center bg-neutral-100 mb-4 p-5 rounded-lg">
            <label className="whitespace-nowrap font-bold"> Seller's Net in Cash, Notes & Retained Assets</label>
            <label className="whitespace-nowrap font-bold">{sellerNetInCashNotesAndRetainedAssets}</label>
          </div>
        </div>
        <div className="mt-2">
          <div className="flex justify-between items-center bg-neutral-100 p-5 rounded-lg">
            <label className="whitespace-nowrap font-bold">Goodwill Check</label>
            <label className="whitespace-nowrap font-bold">{goodwillCheck}</label>
          </div>
        </div>
      </div>
    </div>
  )
}

const mapDispatchToProps = (dispatch) => ({
 dispatchGenerateAssetSaleDealStructureReport() {
   dispatch(generateAssetSaleDealSplitReport())
 },

  dispatchUpdateAssetSaleDealStructureReport({ splitReportKey }, {
    assetSaleDealOwner,
    assetSaleDealItemValue
  }) {
   dispatch(updateAssetSaleDealSplitReport({ splitReportKey }, {
     assetSaleDealOwner,
     assetSaleDealItemValue
   }))
  }
})

const mapStateToProps = (state) => ({
  assetSaleDealSplitReport: state.financials.assetSaleDealSplitReport,
  currentGoodwillReport: state.financials.currentGoodwillReport,
  currentCompanyBalanceSheetReport: state.financials.currentCompanyBalanceSheetReport
})


export default connect(mapStateToProps, mapDispatchToProps)(AssetSaleDealStructureSplit)